import typeCheck from 'common/util/typeCheck';

import {
  APPLICATION_FORM_TYPE_GUARANTOR_APPLICATION,
} from 'common/householdApplication/applicationFormFields';

import {
  SR_API_ACTION_HOUSEHOLD_START_GUARANTOR_APPLICATION,
} from 'api/actionTypes';

import getHouseholdApplicationsAction from 'client/actions/Household/getApplications';
import redirectToApplicationFormAction from 'client/actions/Household/redirectToApplicationForm';

export default async function startGuarantorApplication(
  { state, history, apiClient },
  { householdId, listingId } = {},
) {
  typeCheck('householdId::PositiveNumber', householdId);
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('history::NonEmptyObject', history);

  const currentUserId = state.get(['currentUser', 'id']);

  await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_START_GUARANTOR_APPLICATION,
    state: state,
    payload: {
      householdId,
      listingId,
    },
  });

  await getHouseholdApplicationsAction({ state, apiClient }, {
    userId: currentUserId,
  });

  await redirectToApplicationFormAction({ state, history, apiClient }, {
    householdId: householdId,
    listingId: listingId,
    formType: APPLICATION_FORM_TYPE_GUARANTOR_APPLICATION,
  });
}
